import { startCase } from 'lodash';
import {
  formatCurrencyOnBlur,
  aggregateProjects,
} from '../../../helpers/utils';

const INFO_KEYS = [
  'name',
  'tax_id',
  'type',
  'phone',
  'fax',
  'email',
  'address',
  'website',
  'notes',
];

export const getFunderReportExcelData = (funder: any) => {
  const { hours, projects, ...statuses } = aggregateProjects(funder.projects);
  const clients = funder.clients.map(({ fullName }) => fullName).join('; ');

  const infoRows = INFO_KEYS.filter((key) => funder[key] != null).map((key) => [
    startCase(key),
    funder[key] || '',
  ]);

  const funderInfoSheet = [['Funder Information'], ...infoRows];

  const statusRows = Object.entries(
    statuses as Record<string, { count: any; amount: any }>,
  ).map(([status, values]) => [
    startCase(status),
    values.count,
    values.amount !== 0 ? formatCurrencyOnBlur(values.amount.toString()) : '-',
  ]);

  const projectsSheet = [
    ['Projects Breakdown'],
    ['Clients', clients],
    ['Total Projects', projects.count],
    [
      'Total Amount',
      projects.amount !== 0
        ? formatCurrencyOnBlur(projects.amount.toString())
        : 'No Recorded Info',
    ],
    ['Total Hours', hours],
    [],
    ['Status', 'Count', 'Amount'],
    ...statusRows,
  ];

  const contactRows = (funder.contacts || []).map((c) => [
    c.full_name || '',
    c.phone || '',
    c.email || '',
    c.company || '',
  ]);

  const contactsSheet = [['Name', 'Phone', 'Email', 'Company'], ...contactRows];

  return [
    { name: 'Funder Info', data: funderInfoSheet },
    { name: 'Projects Breakdown', data: projectsSheet },
    { name: 'Contacts', data: contactsSheet },
  ];
};
